import Navigation from "../Navigation/Navigation";
import { useNavigate, Link, NavLink, useLocation } from "react-router-dom";
import { FaSortUp, FaSortDown } from "react-icons/fa";
import "./ManageBusiness.css";
import { MdKeyboardArrowLeft, MdSearch } from "react-icons/md";
import { useState, useEffect } from "react";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";
import { DeleteMappedBusiness } from "../../Utils/Api/DeleteMappedBusiness";
import { toast } from "react-toastify";
import { Button, Spinner, InputGroup, Form, Modal } from "react-bootstrap";
import { GetMappedBussinesssLIstTable } from "../../Utils/Api/GetMappedBussinesssLIstTable";
import deleteIcon from "./../../assets/delete.svg";
import deleteSymbol from "./../../assets/DeleteIcon.svg";

const ManageBusiness = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [currentTab, setCurrentTab] = useState("");
  const [businessList, setBusinessList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [sortConfig, setSortConfig] = useState({
    key: "",
    direction: "asc",
  });
  const [totalCount, setTotalCount] = useState(0);

  /* ---------- DELETE MODAL STATE ---------- */
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedBusiness, setSelectedBusiness] = useState(null);

  /* ---------- OPEN DELETE MODAL ---------- */
  const handleDeleteBusiness = (business) => {
    setSelectedBusiness(business);
    setShowDeleteModal(true);
  };

  /* ---------- CONFIRM DELETE ---------- */
  const confirmDeleteBusiness = async () => {
    if (!selectedBusiness) return;

    const payload = {
      business_id: selectedBusiness.map_id,
    };

    setLoading(true);

    const res = await DeleteMappedBusiness(payload, () => navigate("/"));

    setLoading(false);
    setShowDeleteModal(false);
    setSelectedBusiness(null);

    if (res) {
      toast.success("Business deleted successfully", {
        theme: "dark",
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
      });
      setTimeout(() => {
        navigate(0);
      }, 100);
      fetchMappedBusinesses();
    } else {
      toast.error("Failed to delete business", {
        theme: "dark",
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
      });
    }
  };

  /* ---------- ACTIVE TAB ---------- */
  useEffect(() => {
    const path = window.location.href.split("/");
    if (path[6] === "manage-business") {
      setCurrentTab("manage-business");
    }
  }, []);

  /* ---------- FETCH BUSINESS LIST ---------- */
  const fetchMappedBusinesses = async () => {
    setLoading(true);

    const payload = {
      limit: 10,
      offset: 0,
      sort: 0,
      search_value: "",
    };

    const res = await GetMappedBussinesssLIstTable(payload, () =>
      navigate("/"),
    );

    if (res && Array.isArray(res.data)) {
      setBusinessList(res.data);
      setFilteredList(res.data);
      setTotalCount(res.total_count || res.data.length);
    } else {
      setBusinessList([]);
      setFilteredList([]);
      setTotalCount(0);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchMappedBusinesses();
  }, []);

  useEffect(() => {
    if (location.state?.refresh) {
      fetchMappedBusinesses();
      navigate(location.pathname, { replace: true });
    }
  }, [location.state]);

  /* ---------- SEARCH ---------- */
  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearch(value);

    if (!value) {
      setFilteredList(businessList);
      return;
    }

    const filtered = businessList.filter(
      (item) =>
        item.bi_name?.toLowerCase().includes(value) ||
        item.bu_email?.toLowerCase().includes(value),
    );

    setFilteredList(filtered);
  };

  /* ---------- SORT ---------- */
  const handleSort = (key) => {
    let direction = "asc";

    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const sortedData = [...filteredList].sort((a, b) => {
      const valA = a[key]?.toLowerCase() || "";
      const valB = b[key]?.toLowerCase() || "";

      if (valA < valB) return direction === "asc" ? -1 : 1;
      if (valA > valB) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setSortConfig({ key, direction });
    setFilteredList(sortedData);
  };

  return (
    <>
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>

        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to="/dashboard">
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>

          <p className="page-maintitle">My Profile</p>

          <div className="acc-dashboard mt-4">
            <div className="mb-2 tabs_ul">
              <NavLink to="/my-profile/general-info" className="tabs_li">
                General Info
              </NavLink>
              <NavLink to="/my-profile/business-info" className="tabs_li">
                Business Info
              </NavLink>
              <NavLink to="/my-profile/store-info" className="tabs_li">
                Store Info
              </NavLink>
              <NavLink to="/my-profile/subscription" className="tabs_li">
                Subscription
              </NavLink>
              <NavLink
                to="/my-profile/marketplace-membership"
                className="tabs_li"
              >
                Marketplace Membership
              </NavLink>
              <NavLink
                to="/my-profile/manage-business"
                className={
                  currentTab === "manage-business"
                    ? "tabs_li "
                    : "tabs_li activeTab"
                }
              >
                Manage Businesses
              </NavLink>
            </div>

            <div className="manage_flex_div">
              <InputGroup className="search-bar">
                <InputGroup.Text>
                  <MdSearch />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Search business or email"
                  value={search}
                  onChange={handleSearchChange}
                />
                <Button variant="outline-secondary">Search</Button>
              </InputGroup>

              <Button
                onClick={() => navigate("/my-profile/addbusiness/Email")}
                className={`add_business_list ${
                  totalCount >= 6 ? "disabled" : ""
                }`}
                disabled={totalCount >= 6}
              >
                Add Business
              </Button>
            </div>

            <div className="table-responsive-xl black-header mt-4">
              <p className="add_business_para">
                Your business account has the capability to manage other
                business accounts (permission required). To add a business
                account, click on the button to the right and follow the prompt.
                To delete an account, click on the trash icon and confirm
              </p>
              {loading ? (
                <div className="text-center py-4">
                  <Spinner animation="border" />
                </div>
              ) : (
                <table className="recentact-table table ver-middle manage-vou-table">
                  <thead>
                    <tr>
                      <th className="manage_bus_t_head sortable">Sl No</th>
                      <th
                        className="manage_bus_t_head sortable"
                        onClick={() => handleSort("bi_name")}
                      >
                        Business Name{" "}
                        {sortConfig.key === "bi_name" &&
                          (sortConfig.direction === "asc" ? (
                            <FaSortUp />
                          ) : (
                            <FaSortDown />
                          ))}
                      </th>
                      <th
                        className="manage_bus_t_head sortable"
                        onClick={() => handleSort("bu_email")}
                      >
                        Email{" "}
                        {sortConfig.key === "bu_email" &&
                          (sortConfig.direction === "asc" ? (
                            <FaSortUp />
                          ) : (
                            <FaSortDown />
                          ))}
                      </th>
                      <th>Manage</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredList.length === 0 ? (
                      <tr>
                        <td
                          colSpan="4"
                          className="text-center mt-4 no-bussiness-found"
                        >
                          <p className="no-bussi-found">No businesses found</p>
                        </td>
                      </tr>
                    ) : (
                      filteredList.map((business, index) => (
                        <tr key={business.map_id || index}>
                          <td className="manage_bus_t_head">{index + 1}</td>
                          <td className="manage_bus_t_head">
                            {business.bi_name}
                          </td>
                          <td className="manage_bus_t_head">
                            {business.bu_email}
                          </td>
                          <td>
                            <img
                              src={deleteIcon}
                              className="delete-icon"
                              title="Delete Business"
                              onClick={() => handleDeleteBusiness(business)}
                              alt="delete"
                            />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ---------- DELETE CONFIRMATION MODAL ---------- */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton className="modal-header">
          {/* No title in reference */}
        </Modal.Header>

        <Modal.Body className="text-center mb-5 modal-body">
          <img
            src={deleteSymbol}
            alt="Delete Icon"
            className="errorIconImage"
            loading="lazy"
          />

          <p className="py-3 delete-text">
            Are you sure you want to remove{" "}
            <strong>{selectedBusiness?.bi_name}</strong>?
          </p>

          <div className="text-center small-btns mt-4">
            <button
              type="button"
              className="delete-button dele-no"
              onClick={() => setShowDeleteModal(false)}
            >
              No
            </button>

            <button
              type="button"
              className="delete-button dele-col"
              onClick={confirmDeleteBusiness}
              disabled={loading}
            >
              {loading ? "Deleting..." : "Yes"}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <PrivacyTermsConditions />
    </>
  );
};

export default ManageBusiness;
